import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Header from "./components/Header";
import { UserProvider } from './context/UserContext';
import ConfirmEmail from './pages/ConfirmEmail';
import SearchPage from './pages/SearchPage';
import BookDetails from './pages/BookDetails';
import Wishlist from './pages/Wishlist';
import Completed from './pages/Completed';
import TopWishlistPage from './pages/TopWishlistPage';
import TopCompletedPage from './pages/TopCompletedPage';
import TopBooksPage from './pages/TopBooksPage';
import MatchList from './pages/MatchList';
import PrivateProfile from './pages/PrivateProfile';
import PublicProfile from './pages/PublicProfile';
import Footer from './components/Footer';
import ForgotPassword from './pages/ForgotPassword';
import PasswordReset from './pages/PasswordReset';
import ForumPage from './forums/ForumPage';

function App() {
  return (
    <UserProvider>    
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/book/:itemId" element={<BookDetails />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/completed" element={<Completed />} />
          <Route path="/top-wishlist" element={<TopWishlistPage />} />
          <Route path="/top-completed" element={<TopCompletedPage />} />
          <Route path="/top-books" element={<TopBooksPage />} />
          <Route path="/match-list" element={<MatchList />} />
          <Route path="/private-profile" element={<PrivateProfile />} />
          <Route path="/public-profile/:userId" element={<PublicProfile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<PasswordReset />} />
          <Route path="/forum/feedback" element={<ForumPage />} />

          {/* Add more routes as needed */}
        </Routes>
        <Footer />
      </BrowserRouter>
    </UserProvider>
  );
}


export default App;
